import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["disabled", "label"];
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */

import { useTheme } from '@emotion/react'; // @NOTE This is an internal-only component used for both `<Radio />` and `<Checkbox />`

import { jsx as ___EmotionJSX } from "@emotion/react";

const FormChoiceLabel = _ref => {
  let {
    disabled,
    label
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("label", _extends({
    css: [{
      display: 'grid',
      gridTemplateColumns: label && 'auto 1fr',
      gap: label && theme.space.small,
      alignItems: 'start'
    }, disabled && {
      cursor: 'not-allowed',
      opacity: theme.opacity.base
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormChoiceLabel;"]
  }, rest));
};

export default FormChoiceLabel;